export default __webpack_public_path__ + "static/media/thumbnail.6cc6bf56.png";